import React, { useState, useEffect } from 'react';

// ErrorBoundary component
const ErrorBoundary = ({ children }) => {
  const [hasError, setHasError] = useState(false);
  const [errorInfo, setErrorInfo] = useState(null);

  useEffect(() => {
    const handleError = (error, errorInfo) => {
      setHasError(true);
      setErrorInfo(errorInfo);
    };

    // Listen for errors globally
    window.addEventListener('error', handleError);

    return () => {
      window.removeEventListener('error', handleError);
    };
  }, []);

  console.error('error info', errorInfo);

  if (hasError) {
    return (
      <div>
        <h1>Something went wrong.</h1>
        <details>
          <summary>Click to see error details</summary>
          {errorInfo && <pre>{errorInfo.componentStack}</pre>}
        </details>
      </div>
    );
  }

  return children;
};

export default ErrorBoundary;
